import styled from 'styled-components';

export const PreviewStepWrapper = styled.div`
  .read-more {
    &__button {
      color: ${({ theme }) => theme.palette.green};
    }
  }
`;
